module.exports = __webpack_public_path__ + "img/hr-green-hairy-grass-10.6220c1ab.png";